<rb-dialog
  dialogTitle="Simulation editor"
  headline="How to:"
  confirmationButtonLabel="Got it"
  cancelButtonLabel=""
  [alert]="{ type: 'info', errorCode: '' }"
  class="editor-intro-dialog"
>
  <div class="editor-intro-dialog__content">
    <div class="editor-intro-dialog__section">
      <h4 class="editor-intro-dialog__section-title">General use of the editor</h4>
      <p class="editor-intro-dialog__section-text">
        Create local warnings, adjust their settings, and prepare your simulation set before pushing
        it to the backend.
      </p>
      <video
        *ngIf="howToVideoUrl"
        class="editor-intro-dialog__video"
        controls
        playsinline
        preload="metadata"
        type="video/mp4"
        [src]="howToVideoUrl"
      >
        Your browser does not support the video tag.
      </video>
    </div>

    <div class="editor-intro-dialog__section">
      <h4 class="editor-intro-dialog__section-title">
        Import warnings via legacy export format (deprecated in the future)
      </h4>
      <p class="editor-intro-dialog__section-text">
        Use this flow to import older warning payloads and convert them into the current simulation
        format.
      </p>
      <video
        *ngIf="legacyVideoUrl"
        class="editor-intro-dialog__video"
        controls
        playsinline
        preload="metadata"
        [src]="legacyVideoUrl"
      >
        Your browser does not support the video tag.
      </video>
    </div>

    <div class="editor-intro-dialog__section">
      <h4 class="editor-intro-dialog__section-title">Handle corrupted warnings</h4>
      <p class="editor-intro-dialog__section-text">
        If a warning breaks after map changes due to road geometry changes for example, remove it
        and recreate the correct version before the batch is pushed.
      </p>
      <video
        *ngIf="corruptedVideoUrl"
        class="editor-intro-dialog__video"
        controls
        playsinline
        preload="metadata"
        [src]="corruptedVideoUrl"
      >
        Your browser does not support the video tag.
      </video>
    </div>
  </div>

  <label *ngIf="showDontShowAgain" class="editor-intro-dialog__checkbox">
    <input
      type="checkbox"
      [checked]="dontShowAgain"
      (change)="dontShowAgainChange.emit($any($event.target).checked)"
    />
    <span>Don't show this again</span>
  </label>
</rb-dialog>
